module.exports = __webpack_public_path__ + "media/images/favicon-6b3259c58f4356da2cc885357cfda20b.png";